import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {PickupPointFeeListComponent} from "./list/pickup-point-fee-list.component";
import {PickupPointFeeEditComponent} from "./edit/pickup-point-fee-edit.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/pickupPointFee', {template: ''})
            .when('/company/:companyId/pickupPointFee/:id', {template: ''});
    }]);
/***/

const pickupPointFeeRoutes: Routes = [
    {path: 'company/:id/pickupPointFee', component: PickupPointFeeListComponent},
    {path: 'cars-sara-v2/web/company/:id/pickupPointFee', component: PickupPointFeeListComponent},
    {path: 'company/:companyId/pickupPointFee/:id', component: PickupPointFeeEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/pickupPointFee/:id', component: PickupPointFeeEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(pickupPointFeeRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PickupPointFeeRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/pickup-point-fee-routing.module.ts